/** @jsxImportSource ./simboluri-jsx */
import { useT } from "../i18n";
import type { Cheie } from "../i18n";
// NOTELE UNUI PAS — mecanismul unic care a înlocuit secțiunile „Avertismente"
// de pe fiecare pagină de pas.
//
// Întrebarea care le-a desființat, a lui Stefan: «ori pică verificarea și o
// vedem picată, ori trece — atunci ce e cu avertismentele?». Inventarul pe
// proiectul 17 a găsit 160 de avertismente, care erau cinci lucruri diferite
// sub o singură etichetă:
//
//   * CRITERII fără verificare (axialul din grindă peste 0,1·b·h·f_cd,
//     torsiunea peste T_Rd,c) — au devenit verificări adevărate, cu tip în
//     `catalog_verificari.py`, deci pică sau trec și intră în Pasul 19;
//   * DECIZII de proiect (un număr de niveluri forțat din preferințe, o cotă
//     presupusă) — au trecut în `DeciziiPas`, pe pagina pasului care le ia,
//     cu «ce schimbă» și «cum se schimbă»;
//   * LIMITE ale modelului (împingerea pământului pe cutia de subsol) — au
//     trecut în mecanismul «⚠ metodă» (M1…M12), singurul loc unde stau
//     divergențele față de normativ;
//   * DUBLURI ale unui verdict («ancorarea va pica la Pasul 15») — șterse;
//   * ce a RĂMAS: jurnalul calculului. Cum s-a obținut o cifră, ce a fost
//     completat din alt nivel, ce s-a rotunjit. Nu e verdict și nu e decizie —
//     e proveniență, și de-aia nu se mai numește „avertisment".
//
// Componenta asta afișează exact ultima categorie. Dacă cineva e tentat să
// adauge aici o notă care ar putea pica, ea nu e o notă: e o verificare, și
// locul ei e catalogul.
export default function NotePas({
  note,
  titlu = "struct.note.titlu",
  ce = "struct.note.ce",
}: {
  note?: string[] | null;
  titlu?: Cheie;
  ce?: Cheie;
}) {
  const t = useT();
  const lista = (note ?? []).filter(Boolean);
  if (!lista.length) return null;
  return (
    <div className="st-findings">
      <h3>
        {t(titlu)} ({lista.length})
      </h3>
      <div className="sg-muted" style={{ marginBottom: 6 }}>
        {t(ce)}
      </div>
      <table className="sg-table">
        <tbody>
          {lista.map((a, i) => (
            <tr key={i}>
              <td className="sg-mono" style={{ width: 28, textAlign: "right" }}>
                {i + 1}
              </td>
              <td>{a}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
